import React, { createContext, useContext, useState, ReactNode } from "react";
import { GenericToast, TToastTypes } from "../components/modals";

type ToastContextType = {
  label: string | null;
  type: TToastTypes;
  clearLabel: () => void;
  showToast: (toast: { message: string; toastType: TToastTypes }) => void;
};

const initialState: ToastContextType = {
  label: null,
  type: "info",
  clearLabel: () => null,
  showToast: () => null,
};

const ToastContext = createContext<ToastContextType>(initialState);

export const ToastProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [label, setLabel] = useState<string | null>(null);
  const [type, setType] = useState<TToastTypes>("info");

  const showToast = (toast: { message: string; toastType: TToastTypes }) => {
    setLabel(toast.message);
    setType(toast.toastType);
  };

  const clearLabel = () => setLabel(null);

  return (
    <ToastContext.Provider value={{ label, type, showToast, clearLabel }}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used inside ToastProvider");
  }
  return context;
};
